import type { CompanyProduct } from "../../../hooks/useCompanyProducts";

export const calculateProductValuesFromCompanyProduct = (
  product: CompanyProduct,
  cartonCount: number
) => {
  const totalPieces = product.pieces_per_carton
    ? product.pieces_per_carton * cartonCount
    : null;
  const totalWeight = product.weight_per_carton
    ? product.weight_per_carton * cartonCount
    : null;
  const cbm =
    product.carton_length && product.carton_width && product.carton_height
      ? Number(
          (
            (product.carton_length *
              product.carton_width *
              product.carton_height *
              cartonCount) /
            1000000
          ).toFixed(3)
        )
      : null;
  const totalValue =
    product.unit_price && product.pieces_per_carton
      ? product.unit_price * product.pieces_per_carton * cartonCount
      : null;

  return { totalPieces, totalWeight, cbm, totalValue };
};

export const companyProductToBookingProduct = (
  product: CompanyProduct,
  cartonCount: number
) => {
  const { totalPieces, totalWeight, cbm, totalValue } =
    calculateProductValuesFromCompanyProduct(product, cartonCount);

  return {
    name: product.name,
    hs_code: product.hs_code?.toString() ?? null,
    ean: product.ean,
    gross_weight: totalWeight,
    cbm,
    value: totalValue,
    pieces: totalPieces ?? 1,
    cartons: cartonCount,
    isNew: true,
    company_product_id: product.id,
  };
};
